import React from 'react';
import { Stack, Typography } from '@mui/material';
import { ROUTE_REDESIGN } from 'js/constants/pathnames';
import { ROUTE_ENABLE_MARKETPLACE } from 'new/constants/pathnames';
import { ScreenComponent, ScreenConfig } from 'new/routes/RouterManager';
import styles from './EnableMarketplace.module.scss';
import VideoPlayerView from 'js/components/support/video/VideoPlayerView';
import { Button } from 'new/elements/Button';
import { CONTACT_SUPPORT_LINK } from 'js/constants/config';

interface EnableMarketplaceProps {}

// temporary until MP videos are created
const videoItem = {
  videoId: '1033584514',
  displayName: 'Private Date Product Marketplace',
  url: 'https://vimeo.com/1033584514',
  thumbnail:
    'https://i.vimeocdn.com/video/1954731679-c875b202a0d1b2756a9c80cbdf044330abf588c2a029cdf87b7edfc3f5545bf0-d_2400',
  duration: '2:01 mins',
};

export const EnableMarketplace: ScreenComponent<EnableMarketplaceProps> = (
  props: EnableMarketplaceProps,
) => {
  return (
    <section className={styles.container}>
      <Stack gap="40px" className={styles.left}>
        <Typography variant="h1" className={styles.title}>
          Private Marketplace for Data Products
        </Typography>
        <div className={styles.contentSection}>
          <Typography className={styles.subtitle}>
            Unlock the Power of Governed Data Access with a Private Marketplace{' '}
          </Typography>
          <Typography>
            Nexla’s Private Marketplace of Data Products allows teams to publish high value data
            products for discovery and governed access by other teams within the organization.
          </Typography>
        </div>
        <div className={styles.contentSection}>
          <Typography className={styles.subtitle}>Data Product Publishers</Typography>
          <Typography>
            Select high value, high quality Nexsets you have built to be elevated to the Data
            Product Marketplace. Document the Nexsets, and its schema to allow others to easily
            discover and benefit from work you have already done.
          </Typography>
        </div>
        <div className={styles.contentSection}>
          <Typography className={styles.subtitle}>Data Product Users</Typography>
          <Typography>
            Discover Data Products by description, attributes, and other metadata to find high
            quality Data that already exists in your organization. No need to start from scratch.
            Rate the Data Products to help others discover and find what you are already using.
          </Typography>
        </div>
        <div className={styles.contentSection}>
          <Typography className={styles.subtitle}>Administrators and Custodians</Typography>
          <Typography>
            Approve Access Requests from Data Product Users to ensure that Data is provided in
            accordance with company policies and privileges of the requester. Also approve or remove
            Data Product listing into a marketplace.
          </Typography>
        </div>
        <div className={styles.contentSection}>
          <Typography className={styles.subtitle}>Contact Nexla Support to Get Started</Typography>
          <Typography>
            Get in touch with the{' '}
            <a
              href={CONTACT_SUPPORT_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.contactLink}
            >
              Nexla support team
            </a>{' '}
            to discuss your needs and get access to this Data Product Marketplace.{' '}
          </Typography>
        </div>
      </Stack>
      <Stack className={styles.right}>
        <div className={styles.videoPlayer}>
          <VideoPlayerView videoId={videoItem.videoId} videoUrl={videoItem.url} />
        </div>
      </Stack>
    </section>
  );
};

EnableMarketplace.screenConfig = {
  path: `${ROUTE_REDESIGN}${ROUTE_ENABLE_MARKETPLACE}`,
  domain: 'marketplace',
  header: {
    title: 'Enable Marketplace',
    slugTitle: 'Enable Marketplace',
  },
  screenName: 'EnableMarketplace',
} as ScreenConfig<EnableMarketplaceProps>;
